export default "__VITE_ASSET__DZDhf7lG__"